var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.604.085a.97.97 0 0 1 .793 0l7.01 3.142A.972.972 0 0 1 16 4.12v7.736a.97.97 0 0 1-.594.916l-7.01 3.142a.97.97 0 0 1-.792 0l-7.01-3.142a.966.966 0 0 1-.584-.755.967.967 0 0 1-.01-.162V4.122a.966.966 0 0 1 .594-.894L7.604.085ZM1.94 5.619v5.632l5.09 2.282V7.9L1.94 5.619ZM8.97 7.9l5.09-2.282v5.632l-5.09 2.282V7.9ZM3.34 4.12 8 6.21l4.66-2.089L8 2.032l-4.66 2.09Z"
  })));
};
export default SvgBox;